'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return typeof value === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isFunction.js
// module id = 315
// module chunks = 0